module.exports = "query ($taskId: String!) {\n    taskGet(taskId: $taskId) {\n        status\n        error\n        result\n    }\n}\n"